/* Livien - Carrito "Compra 1, llevate 2 gratis" (sin apps) */
(function () {
  if (window.LivienCart) return;

  var TXT = {
    title: 'Tu carrito',
    mix: 'Elige cualquier modelo y color. El descuento se aplica automáticamente.',
    oneAway: '¡Estás a un reloj de llevártelo gratis!',
    step1: 'Reloj 1',
    free: 'Gratis',
    empty: 'Tu carrito está vacío',
    keep: 'Seguir comprando',
    mixMatch: 'Combina tus 3 relojes',
    completeLook: 'Completa el look',
    add: 'AÑADIR',
    original: 'Precio original',
    saved: 'Has ahorrado',
    total: 'Total',
    checkout: 'PAGAR',
    tag: 'COMPRA 1, LLÉVATE 2 GRATIS',
    freeLabel: 'GRATIS'
  };

  var CSS = '' +
    '.lvc-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s;z-index:2147483000}' +
    '.lvc-overlay.is-open{opacity:1;visibility:visible}' +
    '.lvc-panel{position:fixed;top:0;right:0;height:100%;width:440px;max-width:100%;background:#fff;color:#111;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s ease;z-index:2147483001;font-family:inherit;font-size:14px;line-height:1.35;box-shadow:-4px 0 20px rgba(0,0,0,.08)}' +
    '.lvc-panel.is-open{transform:translateX(0)}' +
    '.lvc-panel *{box-sizing:border-box}' +
    '.lvc-head{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid #eee}' +
    '.lvc-title{margin:0;font-size:15px;font-weight:500;display:flex;align-items:center;gap:8px}' +
    '.lvc-count{background:#000;color:#fff;border-radius:100px;font-size:11px;font-weight:600;min-width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;padding:0 6px}' +
    '.lvc-close{background:none;border:0;cursor:pointer;padding:4px;color:#111;font-size:22px;line-height:1}' +
    '.lvc-offer{background:#f2f2f2;padding:10px 16px 12px}' +
    '.lvc-offer p{margin:0;font-size:14px;color:#6b6b6b}' +
    '.lvc-offer strong{color:#111;font-weight:700}' +
    '.lvc-miles{position:relative;margin:12px 6px 4px;height:44px}' +
    '.lvc-track{position:absolute;left:6%;right:6%;top:10px;height:4px;background:#e0e0e0;border-radius:100px;overflow:hidden}' +
    '.lvc-fill{height:100%;background:#1db97a;width:0;transition:width .35s ease}' +
    '.lvc-step{position:absolute;top:0;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:6px;width:80px}' +
    '.lvc-dot{width:24px;height:24px;border-radius:50%;background:#fff;border:2px solid #d6d6d6;display:flex;align-items:center;justify-content:center;transition:all .25s}' +
    '.lvc-step.is-done .lvc-dot{background:#1db97a;border-color:#1db97a}' +
    '.lvc-dot svg{width:12px;height:12px;display:none}' +
    '.lvc-step.is-done .lvc-dot svg{display:block}' +
    '.lvc-step span{font-size:12px;font-weight:600;color:#9a9a9a}' +
    '.lvc-step.lvc-s0 span{color:#111}' +
    '.lvc-step.is-done span{color:#1db97a}' +
    '.lvc-step.lvc-s0.is-done span{color:#111}' +
    '.lvc-body{flex:1;overflow-y:auto}' +
    '.lvc-items{padding:0 16px}' +
    '.lvc-item{display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #f0f0f0;position:relative}' +
    '.lvc-item:last-child{border-bottom:0}' +
    '.lvc-img{width:72px;height:72px;flex:0 0 72px;background:#f2f2f2;border-radius:4px;overflow:hidden;display:flex;align-items:center;justify-content:center}' +
    '.lvc-img img{width:100%;height:100%;object-fit:cover}' +
    '.lvc-info{flex:1;min-width:0;padding-right:18px}' +
    '.lvc-name{font-size:14px;text-transform:uppercase;margin:0 0 2px;display:flex;flex-wrap:wrap;align-items:center;gap:6px}' +
    '.lvc-tag{display:inline-flex;align-items:center;gap:4px;background:#f2f2f2;border-radius:4px;font-size:10px;font-weight:600;padding:2px 6px;letter-spacing:.02em}' +
    '.lvc-variant{color:#6b6b6b;font-size:13px;margin:0 0 8px}' +
    '.lvc-row{display:flex;align-items:center;justify-content:space-between}' +
    '.lvc-qty{display:inline-flex;align-items:center;border:1px solid #e3e3e3;border-radius:4px;height:32px}' +
    '.lvc-qty button{background:none;border:0;width:30px;height:30px;cursor:pointer;font-size:16px;color:#111}' +
    '.lvc-qty span{min-width:22px;text-align:center;font-size:14px}' +
    '.lvc-price{font-size:14px;text-align:right}' +
    '.lvc-price s{color:#e02020;margin-right:6px}' +
    '.lvc-remove{position:absolute;right:0;top:14px;background:none;border:0;color:#999;cursor:pointer;font-size:16px;line-height:1}' +
    '.lvc-empty{padding:40px 16px;text-align:center}' +
    '.lvc-empty button{margin-top:14px;background:#000;color:#fff;border:0;padding:12px 22px;cursor:pointer;font-size:13px;letter-spacing:.05em}' +
    '.lvc-ups{border-top:1px solid #eee;background:#fafafa;padding:12px 16px}' +
    '.lvc-ups-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}' +
    '.lvc-ups-head p{margin:0;font-size:15px}' +
    '.lvc-arrows{display:flex;gap:6px}' +
    '.lvc-arrows button{width:30px;height:30px;border-radius:50%;border:1px solid #ddd;background:#fff;cursor:pointer;font-size:14px;color:#111}' +
    '.lvc-track-ups{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}' +
    '.lvc-track-ups::-webkit-scrollbar{display:none}' +
    '.lvc-card{flex:0 0 100%;min-width:0;width:100%;scroll-snap-align:start;display:flex;align-items:center;gap:12px;background:#fff;border:1px solid #e6e6e6;border-radius:8px;padding:10px}' +
    '.lvc-card .lvc-img{width:64px;height:64px;flex-basis:64px}' +
    '.lvc-card-info{flex:1;min-width:0;overflow:hidden}' +
    '.lvc-card-info p{margin:0 0 2px;font-size:13px;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.lvc-card-info small{color:#6b6b6b;font-size:12px;display:block;margin-bottom:2px}' +
    '.lvc-card-info s{color:#e02020;margin-right:6px;font-size:13px}' +
    '.lvc-card button{flex:0 0 auto;background:#000;color:#fff;border:0;padding:10px 16px;font-size:12px;letter-spacing:.05em;cursor:pointer;white-space:nowrap}' +
    '.lvc-foot{border-top:1px solid #eee;padding:12px 16px 16px;background:#fff}' +
    '.lvc-line{display:flex;justify-content:space-between;align-items:center;font-size:13px;margin-bottom:6px}' +
    '.lvc-line.is-saved{color:#e02020}' +
    '.lvc-line.is-total{font-size:16px;padding-bottom:12px;border-bottom:1px solid #e6e6e6;margin-bottom:12px}' +
    '.lvc-checkout{display:block;width:100%;background:#000;color:#fff;border:0;padding:16px;font-size:15px;letter-spacing:.06em;cursor:pointer;text-align:center}' +
    '.lvc-checkout:disabled{opacity:.6}' +
    '.lvc-loading{opacity:.55;pointer-events:none}' +
    '.lvc-pw{background:#f2f2f2;border-radius:12px;padding:14px 16px 12px;margin:0 0 14px;color:#111;font-size:14px;line-height:1.35}' +
    '.lvc-pw .lvc-offer{background:none;padding:0}' +
    '.lvc-miles+p{margin-top:4px!important}' +
    '.lvc-pw-title{margin:0 0 6px;font-size:14px;letter-spacing:.02em;text-transform:uppercase;color:#111}' +
    'cart-drawer,#CartDrawer,.cart-drawer,#cart-drawer,.drawer--cart,[data-cart-drawer]{display:none!important}';

  var CHECK = '<svg viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2l2.3 2.3L9.5 3.8" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TAG_ICON = '<svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M6.6 1H11v4.4L5.4 11 1 6.6 6.6 1z" stroke="#111" stroke-width="1.2"/><circle cx="8.6" cy="3.4" r=".9" fill="#111"/></svg>';

  var state = { cart: null, ups: null, busy: false };
  var root, panel, overlay;

  function money(cents, currency) {
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat((currency || 'MXN') === 'MXN' ? 'es-MX' : 'es-ES', {
        style: 'currency', currency: currency || 'MXN',
        minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return '$' + v.toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }
  function api(url, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opt).then(function (r) { return r.json(); });
  }
  function root_url(p) { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r + p.replace(/^\//, ''); }

  function ensureStyle() {
    if (document.getElementById('lvc-style')) return;
    var st = document.createElement('style'); st.id = 'lvc-style'; st.textContent = CSS; document.head.appendChild(st);
  }

  /* Barra de oferta en la pagina de producto (encima de Agregar al carrito) */
  function renderPW() {
    var cart = state.cart; if (!cart) return;
    ensureStyle();
    var html = '<p class="lvc-pw-title">' + TXT.tag + '</p>' + offerHTMLpw(itemCount(cart), cart);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (panel && panel.contains(f)) return;
      if (f.closest('.lvc-panel,.cart-drawer,cart-drawer,.quick-add-modal,product-recommendations,.product-recommendations,.card-wrapper,.card')) return;
      var btn = f.querySelector('[name="add"],[type="submit"]'); if (!btn) return;
      var anchor = btn.closest('.product-form__buttons') || btn;
      var w = f.querySelector('.lvc-pw');
      if (!w) { w = document.createElement('div'); w.className = 'lvc-pw'; anchor.parentNode.insertBefore(w, anchor); }
      w.innerHTML = html;
    });
  }

  function build() {
    ensureStyle();
    root = document.createElement('div'); root.id = 'lvc-root';
    root.innerHTML = '<div class="lvc-overlay"></div><aside class="lvc-panel" role="dialog" aria-modal="true" aria-label="' + TXT.title + '"></aside>';
    document.body.appendChild(root);
    overlay = root.querySelector('.lvc-overlay'); panel = root.querySelector('.lvc-panel');
    overlay.addEventListener('click', close);
    panel.addEventListener('click', onPanelClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function itemCount(cart) { return cart ? cart.item_count : 0; }

  function offerHTML(n,cart){var S=3,inSet=n%S,free=Math.floor(n/S)*2,miss=S-inSet,done=n===0?0:inSet===0?3:inSet,saved=cart?cart.original_total_price-cart.total_price:0,sv=saved>0?" Has ahorrado "+money(saved,cart.currency)+".":"",top,bottom;if(n===0){top=TXT.mix;bottom="Añade <strong>3 relojes</strong> y paga solo 1: el 2.º y el 3.º te salen gratis."}else if(free===0&&miss>1){top="Llevas <strong>1 reloj</strong>. El descuento se aplica al añadir el 3.º";bottom="Añade <strong>2 más</strong> y sigues pagando solo 1."}else if(free===0){top="<strong>¡Estás a 1 reloj de llevarte 2 gratis!</strong>";bottom="Añade <strong>1 más</strong> y <strong>2 de los 3</strong> serán gratis."}else{top="<strong>"+free+" de tus "+n+" relojes son gratis.</strong>"+sv;bottom=inSet===0?"Añade <strong>3 más</strong> y llévate otros 2 gratis.":"Añade <strong>"+miss+" más</strong> para llevarte 2 gratis más."}var B=window.__lvcB||(window.__lvcB={from:done,to:done,t:0}),now=Date.now();if(done!==B.to){B.from=B.to;B.to=done;B.t=now}var anim=now-B.t<900,d0=anim?B.from:done,p0=d0<=1?0:d0===2?50:100;if(!document.getElementById("lvc-dots-css")){var st=document.createElement("style");st.id="lvc-dots-css";st.textContent=".lvc-offer .lvc-step.lvc-pop .lvc-dot{animation:lvcPop .45s ease}@keyframes lvcPop{0%{transform:scale(1)}45%{transform:scale(1.3)}100%{transform:scale(1)}}.lvc-offer .lvc-track .lvc-fill{display:block!important;transition:width .5s cubic-bezier(.4,0,.2,1)}.lvc-offer.lvc-chg>p{animation:lvcIn2 .45s ease both}@keyframes lvcIn2{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}";document.head.appendChild(st)}if(anim)setTimeout(function(){document.querySelectorAll(".lvc-offer[data-done]").forEach(function(o){var to=+o.getAttribute("data-done"),f=o.querySelector(".lvc-fill");if(f)f.style.width=(to<=1?0:to===2?50:100)+"%";o.querySelectorAll(".lvc-step").forEach(function(s,i){if(to>i&&!s.classList.contains("is-done")){setTimeout(function(){s.classList.add("is-done","lvc-pop")},150+i*200)}else if(to<=i)s.classList.remove("is-done")})})},60);var steps=[TXT.step1,TXT.free,TXT.free].map(function(l,i){return'<div class="lvc-step lvc-s'+i+(d0>i?" is-done":"")+'" style="left:'+(6+i*44)+'%"><div class="lvc-dot">'+CHECK+"</div><span>"+l+"</span></div>"}).join("");return'<div class="lvc-offer'+(anim?" lvc-chg":"")+'" data-done="'+done+'"><p>'+top+'</p><div class="lvc-miles"><div class="lvc-track"><div class="lvc-fill" style="width:'+p0+'%"></div></div>'+steps+"</div><p>"+bottom+"</p></div>"}function offerHTMLpw(n,cart){var S=3,G=2,inSet=n%S,free=Math.floor(n/S)*G,miss=S-inSet,saved=cart?cart.original_total_price-cart.total_price:0,sv=saved>0?" Has ahorrado "+money(saved,cart.currency)+".":"",top,bottom,pct;if(n===0){top=TXT.mix;bottom="Añade <strong>3 relojes</strong> y paga solo 1: el 2.º y el 3.º te salen gratis.";pct=0}else if(free===0&&miss>1){top="Llevas <strong>1 reloj</strong>. El descuento se aplica al añadir el 3.º";bottom="Añade <strong>2 más</strong> y sigues pagando solo 1.";pct=33}else if(free===0){top="<strong>¡Estás a 1 reloj de llevarte 2 gratis!</strong>";bottom="Añade <strong>1 más</strong> y <strong>2 de los 3</strong> serán gratis.";pct=67}else{top="<strong>"+free+" de tus "+n+" relojes son gratis.</strong>"+sv;bottom=inSet===0?"Añade <strong>3 más</strong> y llévate otros 2 gratis.":"Añade <strong>"+miss+" más</strong> para llevarte 2 gratis más.";pct=inSet===0?100:Math.round(inSet/S*100)}var A=window.__lvcA||(window.__lvcA={from:pct,to:pct,t:0}),now=Date.now();if(pct!==A.to){A.from=A.to;A.to=pct;A.t=now}var anim=now-A.t<700,start=anim?A.from:pct;if(!document.getElementById("lvc-bar-css")){var st=document.createElement("style");st.id="lvc-bar-css";st.textContent=".lvc-panel .lvc-offer2{margin:10px 12px 4px;border-radius:12px;padding:14px 16px}.lvc-offer2 p{margin:0;font-size:14px;line-height:1.45;color:#6b6b6b}.lvc-offer2 p strong{color:#111;font-weight:700}.lvc-offer2 .lvc-t1{margin-bottom:12px}.lvc-offer2 .lvc-t2{margin-top:12px}.lvc-offer2 .lvc-bar{display:block!important;height:8px;border-radius:100px;background:#e4e4e4;overflow:hidden}.lvc-offer2 .lvc-bar .lvc-bar-fill{display:block!important;height:100%;border-radius:100px;background:#05B67A;transition:width .7s cubic-bezier(.4,0,.2,1)}.lvc-offer2.lvc-chg p{animation:lvcIn .45s ease both}.lvc-offer2.lvc-chg .lvc-t2{animation-delay:.1s}@keyframes lvcIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lvc-pw .lvc-pw-title{font-size:16px;font-weight:500;margin:0 0 6px}";document.head.appendChild(st)}if(anim)setTimeout(function(){document.querySelectorAll(".lvc-bar-fill[data-to]").forEach(function(f){f.style.width=f.getAttribute("data-to")+"%"})},60);return'<div class="lvc-offer lvc-offer2'+(anim?" lvc-chg":"")+'"><p class="lvc-t1">'+top+'</p><div class="lvc-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="'+pct+'"><div class="lvc-bar-fill" data-to="'+pct+'" style="width:'+start+'%"></div></div><p class="lvc-t2">'+bottom+"</p></div>"}

  function lineRows(item, idx, cur) {
    var line = idx + 1;
    var unit = item.original_price;
    var disc = (item.original_line_price || 0) - (item.final_line_price || 0);
    var freeUnits = unit > 0 ? Math.min(item.quantity, Math.round(disc / unit)) : 0;
    var paidUnits = item.quantity - freeUnits;
    var titles = (item.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean);
    var hasTag = disc > 0;
    var tag = hasTag ? '<span class="lvc-tag">' + TAG_ICON + esc(titles[0] || TXT.tag) + '</span>' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : (item.product_type || '');
    function row(qty, priceHTML, withTag) {
      return '<div class="lvc-item" data-line="' + line + '" data-qty="' + item.quantity + '">' +
        '<a class="lvc-img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + img(item.image, 160) + '" alt="">' : '') + '</a>' +
        '<div class="lvc-info"><p class="lvc-name">' + esc(item.product_title) + (withTag ? tag : '') + '</p>' +
        (variant ? '<p class="lvc-variant">' + esc(variant) + '</p>' : '') +
        '<div class="lvc-row"><div class="lvc-qty"><button type="button" data-act="dec" aria-label="Quitar uno">&minus;</button><span>' + qty + '</span><button type="button" data-act="inc" aria-label="Añadir uno">+</button></div>' +
        '<div class="lvc-price">' + priceHTML + '</div></div></div>' +
        '<button type="button" class="lvc-remove" data-act="rm" aria-label="Eliminar">&times;</button></div>';
    }
    if (freeUnits > 0 && paidUnits > 0) {
      return row(paidUnits, money(unit * paidUnits, cur), true) +
        row(freeUnits, '<s>' + money(unit * freeUnits, cur) + '</s>' + money(0, cur), true);
    }
    if (freeUnits > 0) return row(freeUnits, '<s>' + money(item.original_line_price, cur) + '</s>' + money(item.final_line_price, cur), true);
    return row(item.quantity, money(item.final_line_price, cur), false);
  }

  function upsHTML(n) {
    if (!state.ups || !state.ups.length) return '';
    var cur = state.cart ? state.cart.currency : 'MXN';
    var inCart = {};
    (state.cart ? state.cart.items : []).forEach(function (i) { inCart[i.variant_id] = 1; });
    var list = state.ups.filter(function (u) { return !inCart[u.id]; });
    if (!list.length) list = state.ups;
    var cards = list.map(function (u) {
      return '<div class="lvc-card"><div class="lvc-img">' + (u.img ? '<img src="' + img(u.img, 140) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="lvc-card-info"><p>' + esc(u.title) + '</p>' + (u.variant ? '<small>' + esc(u.variant) + '</small>' : '') +
        '<div>' + (u.compare > u.price ? '<s>' + money(u.compare, cur) + '</s>' : '') + money(u.price, cur) + '</div></div>' +
        '<button type="button" data-act="ups" data-id="' + u.id + '">' + TXT.add + '</button></div>';
    }).join('');
    var head = (n > 0 && n % 3 === 0) ? TXT.completeLook : TXT.mixMatch;
    return '<div class="lvc-ups"><div class="lvc-ups-head"><p>' + head + '</p><div class="lvc-arrows"><button type="button" data-act="prev" aria-label="Anterior">&#8249;</button><button type="button" data-act="next" aria-label="Siguiente">&#8250;</button></div></div><div class="lvc-track-ups">' + cards + '</div></div>';
  }

  function render() {
    var cart = state.cart; renderPW(); if (!panel || !cart) return;
    var n = itemCount(cart), cur = cart.currency;
    var html = '<header class="lvc-head"><p class="lvc-title">' + TXT.title + ' <span class="lvc-count">' + n + '</span></p><button type="button" class="lvc-close" data-act="close" aria-label="Cerrar">&times;</button></header>';
    html += offerHTML(n, cart);
    html += '<div class="lvc-body">';
    if (!n) {
      html += '<div class="lvc-empty"><p>' + TXT.empty + '</p><button type="button" data-act="close">' + TXT.keep.toUpperCase() + '</button></div>';
    } else {
      var rows = cart.items.map(function (it, i) { return lineRows(it, i, cur); }).join('');
      var tmp = document.createElement('div'); tmp.innerHTML = rows;
      var paid = [], free = [];
      [].forEach.call(tmp.children, function (el) { (el.querySelector('.lvc-price s') ? free : paid).push(el.outerHTML); });
      html += '<div class="lvc-items">' + paid.join('') + free.join('') + '</div>';
    }
    html += upsHTML(n) + '</div>';
    if (n) {
      var saved = cart.original_total_price - cart.total_price;
      html += '<div class="lvc-foot">' +
        '<div class="lvc-line"><span>' + TXT.original + '</span><span>' + money(cart.original_total_price, cur) + '</span></div>' +
        (saved > 0 ? '<div class="lvc-line"><span class="lvc-tag">' + TAG_ICON + TXT.tag + '</span><span>&minus;' + money(saved, cur) + '</span></div>' +
          '<div class="lvc-line is-saved"><span>' + TXT.saved + '</span><span>' + money(saved, cur) + '</span></div>' : '') +
        '<div class="lvc-line is-total"><span>' + TXT.total + '</span><span>' + money(cart.total_price, cur) + '</span></div>' +
        '<button type="button" class="lvc-checkout" data-act="checkout">' + TXT.checkout + ' &middot; ' + money(cart.total_price, cur) + '</button></div>';
    }
    panel.innerHTML = html;
    updateBubbles(n);
  }

  function updateBubbles(n) {
    var sel = '.cart-count-bubble span[aria-hidden="true"],[data-cart-count],.cart-count,.cart-item-count,.js-cart-count,.header__cart-count';
    document.querySelectorAll(sel).forEach(function (el) { if (!panel.contains(el)) el.textContent = n; });
  }

  function refresh() { return api(root_url('cart.js')).then(function (c) { state.cart = c; render(); return c; }); }

  function loadUps() {
    if (state.ups) return Promise.resolve();
    return api(root_url('products.json?limit=12')).then(function (d) {
      var out = [];
      (d.products || []).forEach(function (p) {
        p.variants.forEach(function (v) {
          if (v.available === false) return;
          var im = (v.featured_image && v.featured_image.src) || (p.images[0] && p.images[0].src);
          out.push({ id: v.id, title: p.title, variant: v.title === 'Default Title' ? '' : v.title, price: Math.round(parseFloat(v.price) * 100), compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0, img: im });
        });
      });
      state.ups = out.slice(0, 12);
    }).catch(function () { state.ups = []; });
  }

  function setBusy(b) { state.busy = b; if (panel) panel.classList.toggle('lvc-loading', b); }

  function change(line, qty) {
    setBusy(true);
    return api(root_url('cart/change.js'), { line: line, quantity: Math.max(0, qty) })
      .then(function (c) { state.cart = c; render(); })
      .catch(refresh)
      .then(function () { setBusy(false); });
  }

  function addVariant(id, qty) {
    setBusy(true);
    return api(root_url('cart/add.js'), { items: [{ id: id, quantity: qty || 1 }] })
      .then(refresh).then(function () { setBusy(false); });
  }

  function onPanelClick(e) {
    var b = e.target.closest('[data-act]'); if (!b || state.busy) return;
    var act = b.getAttribute('data-act');
    var it = b.closest('.lvc-item');
    if (act === 'close') return close();
    if (act === 'checkout') { b.disabled = true; window.location.href = root_url('checkout'); return; }
    if (act === 'ups') return addVariant(parseInt(b.getAttribute('data-id'), 10), 1);
    if (act === 'prev' || act === 'next') {
      var tr = panel.querySelector('.lvc-track-ups'); if (tr) tr.scrollBy({ left: (act === 'next' ? 1 : -1) * tr.clientWidth, behavior: 'smooth' }); return;
    }
    if (it) {
      var line = parseInt(it.getAttribute('data-line'), 10), q = parseInt(it.getAttribute('data-qty'), 10);
      if (act === 'inc') return change(line, q + 1);
      if (act === 'dec') return change(line, q - 1);
      if (act === 'rm') {
        var shown = parseInt(it.querySelector('.lvc-qty span').textContent, 10);
        return change(line, q - shown);
      }
    }
  }

  function open() {
    if (!root) build();
    loadUps().then(refresh).then(function () {
      overlay.classList.add('is-open'); panel.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    });
  }
  function close() {
    if (!panel) return;
    overlay.classList.remove('is-open'); panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* Interceptar "Agregar al carrito" del tema */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"],[name="add"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var fd = new FormData(f);
    fetch(root_url('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (r) { if (r && r.status && r.description) alert(r.description); open(); })
      .catch(open)
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  }, true);

  /* Abrir el carrito desde el icono del header */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"],a[href$="/cart"],#cart-icon-bubble,[data-cart-toggle],[data-drawer-toggle="cart"],.header__icon--cart,.js-cart-toggle');
    if (!a || (panel && panel.contains(a))) return;
    if (/\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);

  window.LivienCart = { open: open, close: close, refresh: refresh };
  if (document.querySelector('form[action*="/cart/add"]')) refresh();
})();
